import { render } from "./Responses.vue?vue&type=template&id=ed9d986c&scoped=true"
import script from "./Responses.vue?vue&type=script&lang=js"
export * from "./Responses.vue?vue&type=script&lang=js"

import "./Responses.vue?vue&type=style&index=0&id=ed9d986c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed9d986c"]])

export default __exports__